module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-queen.cfba021e.svg";